module.exports = __webpack_public_path__ + "img/big-icon-alert.3158ff30.svg";